module.exports = __webpack_public_path__ + "img/tree-06-h-leaves.622d9492.png";